import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation AddToMetric($type: String!, $relatedId: ID!, $count: Int) {
    addToMetric(type: $type, relatedId: $relatedId, count: $count) {
      result
    }
  }
`

type UseAddToMetricResultProps = [
  (type: string, relatedId: string, count?: number) => Promise<void>,
  { loading: boolean },
]

export default function useAddToMetric(opts = {}): UseAddToMetricResultProps {
  const [mutate, { loading }] = useMutation(mutation, opts)

  const addToMetric = async (type: string, relatedId: string, count = 1) => {
    if (!type) throw new Error('type is required')
    if (!relatedId) throw new Error('relatedId is required')

    await mutate({
      variables: {
        type,
        relatedId,
        count,
      },
    })
  }

  return [addToMetric, { loading }]
}
